<template>
    <common-content-spacer height="small">
        <div class="offer">
            <common-content-spacer height="medium">
                <common-table v-if="prefill?.offerCategories?.length">
                    <thead>
                        <tr>
                            <th class="table--title">
                                {{ $t('forms.offer.create_offer.table.title') }}
                            </th>
                            <th class="table--price">
                                {{ $t('forms.offer.create_offer.table.price') }}
                            </th>
                            <th class="table--length">
                                {{ $t('forms.offer.create_offer.table.length') }}
                            </th>
                            <th class="table--description">
                                {{ $t('forms.offer.create_offer.table.description') }}
                            </th>
                            <th class="table--action">
                                {{ $t('forms.offer.create_offer.table.actions') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in prefill.offerCategories" :key="item.id">
                            <td :data-label="$t('forms.offer.create_offer.table.title')" class="table--title">
                                {{ item?.titleTextContent.originalText }}
                            </td>
                            <td :data-label="$t('forms.offer.create_offer.table.price')" class="table--price">
                                {{ offerPrice(item) }}
                            </td>
                            <td :data-label="$t('forms.offer.create_offer.table.length')">
                                {{ getAppointmentLengthLabel(item.appointmentLength) }}
                            </td>
                            <td :data-label="$t('forms.offer.create_offer.table.description')" class="table--description">
                                {{ item?.descriptionTextContent?.originalText }}
                            </td>
                            <td :data-label="$t('forms.offer.create_offer.table.actions')" class="table--action">
                                <span>
                                    <common-icon name="reservation" size="medium" @click="editOffer(item)"></common-icon>
                                    <common-icon name="trash" size="medium" @click="openRemoveOfferModal(item.id)"></common-icon>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </common-table>
                <div v-else class="offer--warning">{{ $t('forms.offer.create_offer.errors.category.warning') }}</div>
            </common-content-spacer>
        </div>
        <common-buttons align="left" class="buttons__spacing--small">
            <div>
                <common-button
                    :isSubmittable="false"
                    type="secondary"
                    size="medium-small"
                    :label="$t('common.microcopy.add')"
                    @click="openAddNewOfferModal"
                ></common-button>
            </div>
        </common-buttons>
        <add-new-offer-category-modal
            v-if="isAddNewOfferCategoryModalOpen"
            :prefill="prefill"
            :categoryId="categoryId"
            @close="closeAddNewOfferModal"
            @offer-added="offerAdded"
        ></add-new-offer-category-modal>
        <common-yes-no-modal
            v-if="isDeleteOfferModalOpen"
            :showWarningIcon="true"
            height="tiny"
            :headingText="$t('modals.delete_offer.title')"
            :noButtonText="$t('common.microcopy.false')"
            :yesButtonText="$t('common.microcopy.true')"
            @close="isDeleteOfferModalOpen = false"
            @continue="removeOffer()"
        ></common-yes-no-modal>
    </common-content-spacer>
</template>

<script>
    import AddNewOfferCategoryModal from 'components/modals/offer/AddNewOfferCategoryModal'
    import PriceMixin from 'mixins/PriceMixin'
    import OfferAPI from 'api/OfferAPI'
    import AppointmentLengthEnum from 'enums/appointment_length.enum'
    import TranslateMixin from 'mixins/TranslateMixin'

    export default {
        mixins: [PriceMixin, TranslateMixin],
        components: { AddNewOfferCategoryModal },
        props: {
            prefill: { type: Object, default: undefined },
        },
        data() {
            return {
                isAddNewOfferCategoryModalOpen: false,
                isDeleteOfferModalOpen: false,
                categoryId: undefined,
                category: {},
            }
        },

        computed: {
            isServiceForCompany() {
                return !!this.prefill.location.companyServiceProvider
            },
        },

        methods: {
            openAddNewOfferModal() {
                this.isAddNewOfferCategoryModalOpen = true
            },

            closeAddNewOfferModal() {
                this.categoryId = undefined
                this.isAddNewOfferCategoryModalOpen = false
            },

            offerAdded() {
                this.closeAddNewOfferModal()
                this.emitEvent({ name: 'offer-changed', payload: true })
            },

            offerPrice(offer) {
                let price = this.setPrice(offer[`price${this.prefill.currency}`])

                return `${price} ${this.prefill.currency}`
            },

            getAppointmentLengthLabel(value) {
                return AppointmentLengthEnum[this.$i18n.locale].reverse().find((option) => Number(option.value) === value)?.label
            },

            openRemoveOfferModal(id) {
                this.categoryId = id
                this.isDeleteOfferModalOpen = true
            },

            removeOffer() {
                this.isLoading = true
                const req = this.isServiceForCompany ? OfferAPI.deleteCompanyOfferCategory : OfferAPI.deleteUserOfferCategory
                req({ id: this.categoryId, companyId: this.prefill?.location?.companyServiceProvider?.id }).then(() => {
                    this.isDeleteOfferModalOpen = false
                    this.isLoading = false
                    this.categoryId = undefined
                    this.emitEvent({ name: 'offer-changed', payload: true })
                })
            },

            editOffer(category) {
                this.categoryId = category.id
                this.openAddNewOfferModal()
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    .offer {
        .table {
            @media screen and (min-width: 820px) {
                &--title {
                    width: 200px;
                }

                &--price {
                    width: 100px;
                }

                &--action {
                    width: 100px;
                    .icon {
                        cursor: pointer;
                        margin-right: 10px;

                        &:hover {
                            color: $color--accent-1;
                        }
                    }
                }
            }
        }

        &--warning {
            color: $color--accent-4;
        }
    }
</style>
